export class CollapseBox {
	readonly $container: HTMLElement;
	private $content: HTMLElement | null;
	private $button: HTMLButtonElement | null;
	private $buttonText: HTMLSpanElement | null;
	private resizeObserver: ResizeObserver | null = null;
	private hadOverflowInitially = false;
	private ignoreResize = false;
	private simpleMode: boolean;
	private textExpand: string;
	private textCollapse: string;

	private readonly classShown: string = 'collapse-box--shown';
	private readonly classHiddenContent = 'collapse-box__content--hidden';
	private readonly classHiddenButton: string = 'collapse-box__button--hidden';

	constructor(selector: HTMLElement) {
		this.$container = selector;
		if (!this.$container) return;

		const button = this.$container.querySelector('.js-collapse-box__button');
		const useShortText = button?.hasAttribute('data-collapse-box-short-text');

		this.textExpand = useShortText ? 'Развернуть' : 'Развернуть описание';
		this.textCollapse = useShortText ? 'Свернуть' : 'Свернуть описание';

		this.init();
	}

	public init(): void {
		this.$content = this.$container.querySelector('.collapse-box__content');
		this.$button = this.$container.querySelector('.js-collapse-box__button');
		this.$buttonText = this.$button?.querySelector('.js-collapse-box__button-text');
		if (!this.$content || !this.$button || !this.$buttonText) return;

		this.simpleMode = this.$content.classList.contains(this.classHiddenContent);

		if (this.simpleMode) {
			const isShown = this.$container.classList.contains(this.classShown);
			this.$content.classList.toggle(this.classHiddenContent, !isShown);
			this.updateButtonText();
		}

		if (!this.simpleMode) {
			this.hadOverflowInitially = this.isOverflowing(this.$content);
			this.updateButtonVisibility();

			this.resizeObserver = new ResizeObserver(() => {
				if (this.ignoreResize) return;
				this.handleResize();
			});
			this.resizeObserver.observe(this.$content);
		}

		this.$button.addEventListener('click', this.toggle);
	}

	private handleResize(): void {
		const isOverflowing = this.isOverflowing(this.$content);

		if (isOverflowing) {
			this.hadOverflowInitially = true;
		} else if (!isOverflowing) {
			if (this.$container.classList.contains(this.classShown)) {
				this.$container.classList.remove(this.classShown);
				this.hadOverflowInitially = false;
			} else {
				this.hadOverflowInitially = false;
			}
		}

		this.updateButtonVisibility();
	}

	private updateButtonVisibility(): void {
		if (this.simpleMode) return;

		const isOverflowing = this.isOverflowing(this.$content);
		if (isOverflowing || this.hadOverflowInitially) {
			this.$button.classList.remove(this.classHiddenButton);
		} else {
			this.$button.classList.add(this.classHiddenButton);
		}

		this.updateButtonText();
	}

	public toggle = (): void => {
		this.ignoreResize = true;

		if (this.simpleMode) {
			const isHidden = this.$content?.classList.toggle(this.classHiddenContent);
			this.$container.classList.toggle(this.classShown, !isHidden);
		} else {
			this.$container.classList.toggle(this.classShown);
		}

		this.updateButtonText();
		setTimeout(() => {
			this.ignoreResize = false;
		}, 200);
	};

	private updateButtonText(): void {
		const isShown = this.$container.classList.contains(this.classShown);
		this.$buttonText.textContent = isShown ? this.textCollapse : this.textExpand;
	}

	private isOverflowing(element: HTMLElement): boolean {
		return element.scrollHeight > element.clientHeight + 1;
	}

	public destroy(): void {
		this.$button?.removeEventListener('click', this.toggle);
		this.resizeObserver?.disconnect();
	}
}
